module.exports = __webpack_public_path__ + "static/media/aws-cloudFormation.80229d2f.svg";